import React, { lazy } from "react";
const Category = lazy(() =>
  import("../view/categoryCustom/category/Categorys")
);
const LookGoods = lazy(() =>
  import("../view/categoryCustom/lookGoods/LookGoods")
);
const SaleAnalysis = lazy(() =>
  import("../view/categoryCustom/saleAnalysis/SaleAnalysis")
);
const CustomAnalysis = lazy(() =>
  import("../view/categoryCustom/custom/CustomAnalysis")
);
const category = [
  // 展厅品类分析
  {
    path: "/categoryCustom/category",
    component: Category,
  },
  // 查看款式
  {
    path: "/categoryCustom/lookGoods",
    component: LookGoods,
  },
  // 展厅销售分析
  {
    path: "/categoryCustom/saleAnalysis",
    component:SaleAnalysis,
  },
  // 展厅客户分析明细
  {
    path: "/categoryCustom/customAnalysis",
    component:CustomAnalysis,
  },
];
export default category;
